module.exports = __webpack_public_path__ + "static/img/2.2d9e5d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/m/2.png
// module id = 1oBD
// module chunks = 1 2